<template>
    <NuxtLink :to="localePath('/')" class="logo-link" :title="$t('header.goHome')">
        <img v-show="props.isShow" class="logo-img" src="@/assets/img/gbh_logo.jpg" alt="" />
        <img v-show="!props.isShow" class="logo-img" src="@/assets/img/gbh_logo2.png" alt="" />
    </NuxtLink>
</template>

<script setup>
const props = defineProps({
  isShow: {
    type: Boolean,
    default: true
  }
})
const localePath = useLocalePath()
</script>

<style lang="less" scoped>
.logo-link {
  display: inline-flex;
  align-items: center;
  height: 100%;
  text-decoration: none;
}
.logo-img{
  width: 63px;
  height: 28px;
  object-fit: contain;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.08);
  }
}
@media (max-width: 1200px) {
  .logo-img {
    width: 56px;
    height: 25px;
  }
}
</style>